import { createContext } from 'react';

const CateringEventContext = createContext();
CateringEventContext.displayName = 'CateringEventContext';

export default CateringEventContext;
